export default {"src":"/_next/static/media/arrow-right-white.a84b4f85.svg","height":24,"width":24};